import { ThreadEntityType } from '@enums/thread-entity-type.enum';
import { DateHelper } from '@helpers/date.helper';
import { Actor } from '@models/actor';
import { Status } from '@modules/core/types/status.type';

export interface AuditJson {
  uuid?: string;
  recorded_at?: string;
  actor?: Actor;
  entity_type?: ThreadEntityType;
  property?: string;
  property_type?: string;
  value?: Status;
}

export type AuditSerialized = Pick<AuditJson, 'property_type' | 'property' | 'entity_type'>;

export class Audit {
  constructor(
    public uuid?: string,
    public recordedAt?: Date,
    public actor?: Actor,
    public entityType?: ThreadEntityType,
    public property?: string,
    public propertyType?: string,
    public value?: Status
  ) {}

  static fromJson(json: AuditJson): Audit {
    return new Audit(
      json.uuid,
      json.recorded_at ? DateHelper.toDate(json.recorded_at) : null,
      json.actor ? Actor.fromJson(json.actor) : null,
      json.entity_type,
      json.property,
      json.property_type,
      json.value
    );
  }

  static toJson(audit: Audit): AuditSerialized {
    return {
      property_type: audit.propertyType,
      property: audit.property,
      entity_type: audit.entityType
    };
  }
}
